
import React, { useEffect, useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Badge,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import { Download, Code, Zap, Shield, Users, Star, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { FULL_LOGO_2, USER_LOGO } from '../assets';
import { useDispatch } from 'react-redux';
import { getProfileAPI } from '../redux/auth/slice';


const Resource = ({ getProfileData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedOS, setSelectedOS] = useState('windows');
    const [hoveredCard, setHoveredCard] = useState(null);
    useEffect(() => {
        dispatch(getProfileAPI());
    }, [])
    const platforms = {
        windows: {
            icon: '',
            // icon: '🪟',
            name: 'Windows',
            subtitle: 'Windows 10, 11',
            downloads: [
                { type: '.exe', arch: 'Arm64', primary: true, fileUrl: 'https://devglu-frontend-prod.s3.ap-southeast-1.amazonaws.com/windows/devglu-ai-0.1.0+Setup.exe', filename: 'devglu-backend-0.0.1-win-x64.msi' },
                // { type: 'System Installer', arch: 'x64 Arm64' },
                // { type: '.zip', arch: 'x64 Arm64' },
                // { type: 'CLI', arch: 'x64 Arm64' }
            ]
        },
        // linux: {
        //     icon: '',
        //     // icon: '🐧',
        //     name: 'Linux',
        //     subtitle: 'Ubuntu',
        //     downloads: [
        //         { type: '.deb', arch: 'Arm64', primary: true, fileUrl: 'https://github.com/devglu/devglu-backend/releases/download/v0.0.1/devglu-backend-0.0.1-linux-x64.deb', filename: 'devglu-backend-0.0.1-linux-x64.deb' },
        //         // { type: '.rpm', arch: 'x64 Arm32 Arm64' },
        //         // { type: '.tar.gz', arch: 'x64 Arm32 Arm64' },
        //         // { type: 'Snap Store', arch: 'Snap Store' },
        //         // { type: 'CLI', arch: 'x64 Arm32 Arm64' }
        //     ]
        // },
        mac: {
            icon: '',
            // icon: '🍎',
            name: 'Mac',
            subtitle: 'macOS 10.15+',
            downloads: [
                { type: '.dmg', arch: 'Apple silicon macs', primary: true, fileUrl: 'https://devglu-frontend-prod.s3.ap-southeast-1.amazonaws.com/mac/devglu-ai-0.1.0-arm64.dmg', filename: 'devglu-backend-0.0.1-mac-x64.zip' },
                // { type: 'CLI', arch: 'Intel chip Apple silicon' }
            ]
        }
    };

    const features = [
        {
            icon: <Code className="w-6 h-6" />,
            title: 'IntelliSense',
            description: 'Smart completions based on variable types, function definitions, and imported modules'
        },
        {
            icon: <Zap className="w-6 h-6" />,
            title: 'Debugging',
            description: 'Print debugging is a thing of the past. Debug code right from the editor'
        },
        {
            icon: <Shield className="w-6 h-6" />,
            title: 'Built-in Git',
            description: 'Review diffs, stage files, and make commits right from the editor'
        },
        {
            icon: <Users className="w-6 h-6" />,
            title: 'Extensions',
            description: 'Want even more features? Install extensions to add new languages and tools'
        }
    ];

    const customStyles = `
    <style>
      .hero-section {
        min-height: 100vh;
        background: linear-gradient(135deg, #1a1a1a 0%, #2d3748 50%, #1a1a1a 100%);
        position: relative;
      }

      .animated-bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.3;
        z-index: 1;
      }

      .bg-blob-1 {
        position: absolute;
        top: 10%;
        left: 25%;
        width: 400px;
        height: 400px;
        background: #1a89ff;
        border-radius: 50%;
        filter: blur(80px);
        animation: pulse 4s ease-in-out infinite;
      }

      .bg-blob-2 {
        position: absolute;
        top: 10%;
        right: 25%;
        width: 400px;
        height: 400px;
        background: #0066cc;
        border-radius: 50%;
        filter: blur(80px);
        animation: pulse 4s ease-in-out infinite;
        animation-delay: 2s;
      }

      .bg-blob-3 {
        position: absolute;
        bottom: 10%;
        left: 33%;
        width: 400px;
        height: 400px;
        background: #4da6ff;
        border-radius: 50%;
        filter: blur(80px);
        animation: pulse 4s ease-in-out infinite;
        animation-delay: 4s;
      }

      @keyframes pulse {
        0%, 100% { transform: scale(1); opacity: 0.3; }
        50% { transform: scale(1.1); opacity: 0.5; }
      }

      .hero-content {
        position: relative;
        z-index: 10;
        padding: 5rem 0;
      }

      .gradient-text {
        background: linear-gradient(to right, #1a89ff, #4da6ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }

      .glass-card {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 1rem;
        transition: all 0.3s ease;
      }

      .glass-card:hover {
        background: rgba(255, 255, 255, 0.15);
        border-color: rgba(255, 255, 255, 0.4);
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
      }

      .platform-btn {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: rgba(255, 255, 255, 0.8);
        border-radius: 0.75rem;
        padding: 1rem 1.5rem;
        transition: all 0.3s ease;
        margin: 0.25rem;
      }

      .platform-btn:hover {
        background: rgba(255, 255, 255, 0.2);
        color: white;
        transform: translateY(-2px);
      }

      .platform-btn.active {
        background: #1a89ff;
        color: white;
        transform: scale(1.05);
        box-shadow: 0 10px 30px rgba(26, 137, 255, 0.3);
      }

      .download-card {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 1rem;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
      }

      .download-card:hover {
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
        border-color: rgba(255, 255, 255, 0.4);
      }

      .download-card.primary {
        border: 2px solid #1a89ff;
        box-shadow: 0 0 20px rgba(26, 137, 255, 0.3);
      }

      .recommended-badge {
        position: absolute;
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        background: linear-gradient(to right, #1a89ff, #4da6ff);
        color: white;
        padding: 0.25rem 1rem;
        border-radius: 50px;
        font-size: 0.75rem;
        font-weight: 600;
      }

      .download-btn {
        background: linear-gradient(to right, #1a89ff, #4da6ff);
        border: none;
        color: white;
        font-weight: 600;
        border-radius: 0.75rem;
        transition: all 0.3s ease;
        width: 100%;
        padding: 0.75rem;
      }

      .download-btn:hover {
        background: linear-gradient(to right, #0066cc, #1a89ff);
        transform: translateY(-2px);
        box-shadow: 0 10px 20px rgba(26, 137, 255, 0.4);
      }

      .feature-icon {
        width: 4rem;
        height: 4rem;
        background: linear-gradient(135deg, #1a89ff, #4da6ff);
        border-radius: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.5rem;
        transition: all 0.3s ease;
      }

      .feature-card:hover .feature-icon {
        transform: scale(1.1);
        box-shadow: 0 15px 30px rgba(26, 137, 255, 0.4);
      }

      .stats-section {
        background: linear-gradient(to right, rgba(26, 137, 255, 0.1), rgba(77, 166, 255, 0.1));
        padding: 4rem 0;
      }

      .stat-number {
        font-size: 3rem;
        font-weight: bold;
        color: white;
        transition: color 0.3s ease;
        cursor: pointer;
      }

      .stat-number:hover {
        color: #1a89ff;
      }

      .text-primary-custom {
        color: #1a89ff !important;
      }

      .text-primary-custom:hover {
        color: #4da6ff !important;
      }

      .features-section {
        background: rgba(0, 0, 0, 0.2);
        padding: 5rem 0;
      }

      .intro-badge {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 50px;
        padding: 0.5rem 1.5rem;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 2rem;
      }
    </style>
  `;

    const handleDownload = (fileUrl, filename) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <>
            <div className="topbar_container">
                <div className="topbar_inner">
                    <div className="wordmark_wordmark">
                        <img src={FULL_LOGO_2} width={200} />
                    </div>
                    <div className="topbar-menu_menu">
                        <div aria-haspopup="menu" tabindex="0" aria-expanded="false" id="«R55jddbH1»" className="topbar-menu_button" onClick={() => navigate("/")}>Home</div>
                        <div aria-haspopup="menu" tabindex="0" aria-expanded="false" id="«R95jddbH1»" className="topbar-menu_button" onClick={() => navigate("/resources")}>Resources</div>
                    </div>
                    {localStorage?.getItem("token") ? <>

                        <div className='d-flex gap-2 cursor-pointer'>

                            <img src={USER_LOGO} height={36} />
                            <div className="topbar_rightSection"><a className="menu-button_button">{getProfileData?.name || "Devglu"}</a>
                                {/* <a className="menu-button_button menu-button_primary" onClick={() => navigate("/signup")}>Sign up</a> */}
                            </div>
                        </div>
                    </> : <>
                        <div className="topbar_rightSection"><a className="menu-button_button" onClick={() => navigate("/login")}>Login</a>
                            {/* <a className="menu-button_button menu-button_primary" onClick={() => navigate("/signup")}>Sign up</a> */}
                        </div>

                    </>}

                </div>
            </div>
            <div dangerouslySetInnerHTML={{ __html: customStyles }} />

            <div className="hero-section">
                <div className="animated-bg">
                    <div className="bg-blob-1"></div>
                    <div className="bg-blob-2"></div>
                    <div className="bg-blob-3"></div>
                </div>

                <Container className="hero-content">
                    <Row className="justify-content-center text-center">
                        <Col lg="10">


                            <h1 className="display-1 text-white mb-4" style={{ fontWeight: 'bold', lineHeight: '1.1' }}>
                                Download
                                <span className="gradient-text"> DevGlu.AI</span>
                            </h1>

                            <p className="lead text-white-50 mb-5" style={{ fontSize: '1.25rem', maxWidth: '600px', margin: '0 auto 3rem' }}>
                                Backend development – Smarter, Faster, Better
                            </p>
                        </Col>
                    </Row>

                    {/* Platform Selection */}
                    <Row className="justify-content-center mb-5">
                        <Col lg="8">
                            <div className="d-flex justify-content-center flex-wrap">
                                {Object.entries(platforms).map(([key, platform]) => (
                                    <Button
                                        key={key}
                                        className={`platform-btn ${selectedOS === key ? 'active' : ''}`}
                                        onClick={() => setSelectedOS(key)}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="me-3" style={{ fontSize: '1.5rem' }}>{platform.icon}</span>
                                            <div className="text-start">
                                                <div style={{ fontWeight: '600', fontSize: '1rem' }}>{platform.name}</div>
                                                <small style={{ opacity: 0.8, fontSize: '0.8rem' }}>{platform.subtitle}</small>
                                            </div>
                                        </div>
                                    </Button>
                                ))}
                            </div>
                        </Col>
                    </Row>

                    {/* Download Options */}
                    <Row className="justify-content-center">
                        <Col lg="10">
                            <Row>
                                {platforms[selectedOS].downloads.map((download, index) => (
                                    <Col key={index} md="12" lg="12" className="mb-4">
                                        <div className='d-flex justify-content-center align-items-center'>
                                            <Card
                                                className={`download-card h-100 ${download.primary ? 'primary' : ''}`}
                                                onMouseEnter={() => setHoveredCard(index)}
                                                onMouseLeave={() => setHoveredCard(null)}
                                            >
                                                {/* {download.primary && (
                                                <div className="recommended-badge">
                                                    Recommended
                                                </div>
                                            )} */}

                                                <CardBody className="p-4">
                                                    <div className="d-flex justify-content-between align-items-start mb-4">
                                                        <div>
                                                            <h5 className="text-white mb-2" style={{ fontWeight: '600' }}>
                                                                {download.type}
                                                            </h5>
                                                            <small className="text-white-50">{download.arch}</small>
                                                        </div>
                                                        <Download
                                                            className='ms-5'
                                                            size={24}
                                                            color={hoveredCard === index ? '#1a89ff' : 'rgba(255, 255, 255, 0.6)'}
                                                            style={{
                                                                transition: 'all 0.3s ease',
                                                                transform: hoveredCard === index ? 'rotate(12deg)' : 'rotate(0deg)'
                                                            }}
                                                        />
                                                    </div>

                                                    <Button className="download-btn" onClick={() => handleDownload(download.fileUrl, download.filename)}>
                                                        <div className="d-flex align-items-center justify-content-center">
                                                            Download
                                                            <ArrowRight size={16} className="ms-2" />
                                                        </div>
                                                    </Button>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>

                    {/* Legal Notice */}
                    {/* <Row className="justify-content-center mt-5">
                        <Col lg="8" className="text-center">
                            <small className="text-white-50">
                                By downloading and using Visual Studio Code, you agree to the{' '}
                                <a href="#" className="text-primary-custom text-decoration-none">license terms</a>
                                {' '}and{' '}
                                <a href="#" className="text-primary-custom text-decoration-none">privacy statement</a>.
                            </small>
                        </Col>
                    </Row> */}
                </Container>
            </div>

            {/* Features Section */}
            {/* <div className="features-section">
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-4 text-white mb-4" style={{ fontWeight: 'bold' }}>
                                Why developers love Devglu.AI
                            </h2>
                            <p className="lead text-white-50">
                                Powerful features that make coding faster and more enjoyable
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        {features.map((feature, index) => (
                            <Col key={index} md="6" lg="3" className="mb-4">
                                <Card className="glass-card feature-card h-100 border-0">
                                    <CardBody className="p-4 text-center">
                                        <div className="feature-icon mx-auto">
                                            {React.cloneElement(feature.icon, { size: 24, color: 'white' })}
                                        </div>
                                        <h5 className="text-white mb-3" style={{ fontWeight: '600' }}>
                                            {feature.title}
                                        </h5>
                                        <p className="text-white-50 mb-0" style={{ lineHeight: '1.6' }}>
                                            {feature.description}
                                        </p>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            <div className="stats-section">
                <Container>
                    <Row className="text-center">
                        <Col md="4" className="mb-4">
                            <div className="stat-number">14M+</div>
                            <div className="text-white-50">Monthly Active Users</div>
                        </Col>
                        <Col md="4" className="mb-4">
                            <div className="stat-number">40K+</div>
                            <div className="text-white-50">Extensions Available</div>
                        </Col>
                        <Col md="4" className="mb-4">
                            <div className="stat-number">100+</div>
                            <div className="text-white-50">Programming Languages</div>
                        </Col>
                    </Row>
                </Container>
            </div> */}
        </>

    )
}

export default Resource